import { Rout_create } from './Rout.create'
import { Rout_to } from './Rout'

export interface Rout_NotificationRoutesArgs {
    Noti_NotificationsPage: React.FunctionComponent<unknown>
}

export const Rout_NotificationRoutes = (args: Rout_NotificationRoutesArgs) => [
    Rout_create('/notifications', args.Noti_NotificationsPage),
]

export function Rout_toNotifications() {
    Rout_to(`/notifications`)
}
